import { useCallback, useContext } from 'react';
import { SharedDocument, DocumentType } from 'types/Document';
import { Image } from 'components';
import { makeStyles } from '@mui/styles';
import { AudioIcon, EmlIcon, ExcelIcon, PdfIcon, PowerPointIcon, UnknownIcon, WordIcon } from 'assets/icons/file_icons';
import CreatorIcon from 'views/App/Share/ShareExplorer/FolderContentExplorer/CreatorIcon';
import { deleteModeContext } from 'views/App/Share/ShareExplorer/FolderContentExplorer/DeleteMode/DeleteModeContext';

const useStyles = makeStyles(() => ({
  image: {
    cursor: 'pointer',
    maxHeight: 120,
    maxWidth: 150,
  },
}), { name: 'DocumentPreview' });

const getIconFromDocumentType = (document: SharedDocument, documentType: DocumentType) => {
  switch (documentType) {
    case DocumentType.MUSIC:
      return AudioIcon;
    case DocumentType.EML:
      return EmlIcon;
    case DocumentType.EXCEL:
      return ExcelIcon;
    case DocumentType.PICTURE:
      return document.blob.s3URL;
    case DocumentType.PDF:
      return PdfIcon;
    case DocumentType.POWERPOINT:
      return PowerPointIcon;
    case DocumentType.WORD:
      return WordIcon;
    default:
      return UnknownIcon;
  }
};

export type DocumentPreviewProps = {
  document: SharedDocument;
  documentType: DocumentType;
};

export const DocumentPreview = ({ document, documentType } : DocumentPreviewProps) : JSX.Element => {
  const { isDeleteMode } = useContext(deleteModeContext);
  const classes = useStyles();

  const handleDocumentClick = useCallback(() => {
    if (!isDeleteMode) {
      const url : string = document.blob.s3URL;
      window.open(url);
    }
  }, [document.blob.s3URL, isDeleteMode]);

  const icon = getIconFromDocumentType(document, documentType);
  return (
    <div data-testid='document-preview'>
      <Image
        className={classes.image}
        src={icon}
        onClick={handleDocumentClick}
      />
      <CreatorIcon document={document} />
    </div>
  );
};

export default DocumentPreview;